<template>
    <div>
        <input class="form-control mb-2" type="text"
               :value="filterValue"
               name="filterTrips"
               @input="onChange"
               placeholder="Filter" />
        <trip_table :trips="trips"></trip_table>
    </div>
</template>

<script>

    import trip_table from '../trip/trip_table';

    export default {
        name: "table_view",
        components: {trip_table},
        props: {
            trips: Array,
            updateFilter: Function,
            filterValue: String,
        },
        methods: {
            onChange: function (event) {
                this.updateFilter({name: event.target.name, value: event.target.value});
            }
        }
    }
</script>

<style scoped>

</style>
